import domReady from "@wordpress/dom-ready";
import Recommendation from "./view/recommendation";

type Options = {
    rootSelector: string;
    formSelector: string;
    contentSelector: string;
    templateSelector: string;
    itemSelector: string;
};

const defaultOptions: Options = {
    rootSelector: '.wp-block-singold-wc-product-variation-recommendation',
    formSelector: '.variations_form',
    contentSelector: '.wp-block-singold-wc-product-variation-recommendation-content',
    templateSelector: '.wp-block-singold-wc-product-variation-recommendation-template',
    itemSelector: '.wp-block-singold-wc-product-variation-recommendation-item',
};

class View {
    constructor(private options: Options = defaultOptions) {
        this.options = {
            ...defaultOptions,
            ...options,
        };

        this.init();
    }

    public init(): void {
        // @ts-ignore
        if (typeof jQuery === 'undefined') {
            return;
        }

        const self = this;

        // @ts-ignore
        jQuery(document).on('wc_variation_form', '.variations_form', function (wc_variation_form: HTMLElement, form: VariationForm) {
            // @ts-ignore
            const el = jQuery(this).get(0).querySelector(self.options.rootSelector);
            if (!el) {
                return;
            }

            new Recommendation(el, form, {
                formSelector: self.options.formSelector,
                contentSelector: self.options.contentSelector,
                templateSelector: self.options.templateSelector,
                itemSelector: self.options.itemSelector,
            });

            // TODO: Remove after wp interactivity is working with composite products (rewrite to blocks)
            if (!el.closest('.component_data')) {
                return;
            }

            // @ts-ignore
            jQuery(this).on('click', '.wp-block-accordion-heading__toggle', function () {
                // @ts-ignore
                jQuery(this).closest('.wp-block-accordion-item').toggleClass('is-open');
            });
        });
    }
}

domReady(() => {
    new View();
});

